(function ($, Drupal, drupalSettings) {

  Drupal.behaviors.mbf_articles_list_001 = {
    attach: function (context) {

      function facetsAjaxFixes() {
        $('.block-facet-blockarticlestopics').attr('id', 'block-topics').addClass('block-facets-ajax js-facet-block-id-articlestopics');
        $('.block-facet-blockarticlessectors').attr('id', 'block-sectors').addClass('block-facets-ajax js-facet-block-id-articlessectors');
        $('.block-facet-blockarticleslocations').attr('id', 'block-locations').addClass('block-facets-ajax js-facet-block-id-articleslocations');
      } //-- facetsAjaxFixes

      function resultViewOnloadClear() {
        if (!$('.block-facets-summary-blockarticlessummary .facet-summary-item--clear a').length) {
          setTimeout(function () {
            resultViewOnloadClear();
          }, 100);
        } else {
          $('.block-facets-summary-blockarticlessummary .facet-summary-item--clear a').trigger('click');
        }
      } //-- resultViewOnload

      function articleslistStickySidebarTopSpacing() {
        var topSpacing = 30;

        if (jQuery('#block-mbf-demo-theme-local-tasks').length) {
          topSpacing += jQuery('#block-mbf-demo-theme-local-tasks').position().top + jQuery('#block-mbf-demo-theme-local-tasks').outerHeight();
        }

        if ($('#page > header .region-header').hasClass('fixed-position-show')) {
          topSpacing += parseInt($('#page > header').outerHeight());
        }

        if ($('body').hasClass('user-logged-in') && ($('body').hasClass('toolbar-fixed') || $(window).scrollTop() == 0)) {
          topSpacing += $('#toolbar-administration > #toolbar-bar').outerHeight();
          topSpacing += $('#toolbar-item-administration-tray.toolbar-tray-horizontal').is(':visible') ? $('#toolbar-item-administration-tray').outerHeight() : 0;
          topSpacing += $('.region-local-tasks').length ? $('.region-local-tasks').outerHeight() : 0;
        }

        if (topSpacing !== stickySearchSidebar.options.topSpacing) {
          stickySearchSidebar.options.topSpacing = topSpacing;
          stickySearchSidebar.updateSticky();
        }
      } //-- articleslistStickySidebarTopSpacing

      function facetsAccordion() {
        if ($(window).outerWidth() > 991) {
          $('.mbf-articles-list-results .col-xl-4 .paragraph-type-mbo-accordion-001').css('display', '');
          $('.mbf-articles-list-results .col-xl-4 .paragraph-filters-wrapper').removeClass('open').removeClass('opened');
        }
      } //-- facetsAccordion

      // ==========================================

      // Add hide/show class to form section parents.
      $('.resource-library-results-hidden:not(.resource-library-results)').closest('.mbf-page--section').addClass('resource-library-results-sections');
      $('.resource-library-results-sections .resource-library-results-hidden').show();

      // Hacks to fix facets ajax.
      facetsAjaxFixes();

      // Hide empty accordion facets.
      $('.mbf-articles-list-results .col-xl-4 .mbm-accordion-content').each(function(index, value){
        if ($('.facet-empty', value).length) {
           $(value).closest('.field__item').hide();
        } else {
          $(value).closest('.field__item').show();
        }
      });

      // Update the filter count and show/hide clear.
      if ($('.block-facets-summary-blockarticlessummary li.facet-summary-item--facet').length) {
        $('.mbf-articles-list-results .col-xl-4 .filters-selected .filters-selected-number').text(
          $('.block-facets-summary-blockarticlessummary li.facet-summary-item--facet').length
        );
        $('.mbf-articles-list-results .col-xl-4 .filters-selected').show();
        $('.mbf-articles-list-results .col-xl-4 .field--name-field-o-accordion-title').show();

        if ($('.block-facets-summary-blockarticlessummary li.facet-summary-item--facet').length == 1) {
          $('.mbf-articles-list-results .col-xl-4 .filters-selected .filters-selected-plural').hide();
        } else {
          $('.mbf-articles-list-results .col-xl-4 .filters-selected .filters-selected-plural').show();
        }
      } else {
        $('.mbf-articles-list-results .col-xl-4 .filters-selected ').hide();
        $('.mbf-articles-list-results .col-xl-4 .field--name-field-o-accordion-title').hide();
      }

      // Clear all facets.
      $('body').once('mbf-articles-list-clear-all').on('click', '.mbf-articles-list-results .col-xl-4 .field--name-field-o-accordion-title .mba_btn', function(){
        resultViewOnloadClear();
        return false;
      });

      // Make sure showall is unticked when hierarchy terms are ticked, and reticked when reset.
      $('.mbf-articles-list-results .col-xl-4 form.webform-submission-form').each(function(index, value) {
        $('.facet-item input:checked', value).each(function (subIndex, subValue) {
          if ($(subValue).attr('id').indexOf('-reset-all') < 0) {
            $('label[for="' + $('input:first', $(subValue).closest('form.webform-submission-form')).attr('id')  + '"]').addClass('notransition');
            $('input:first', $(subValue).closest('form.webform-submission-form')).prop('checked', '');
          }
        });
      });
      setTimeout(function (){
        $('.mbf-articles-list-results .col-xl-4 form.webform-submission-form label').removeClass('notransition');
      }, 100);

      // Sticky sidebar.
      if ($('.mbf-articles-list-results > .row > .col-xl-4').length && !$('#sticky-search-sidebar').length && !$('#node-mbf-page-layout-builder-form').length) {
        $('.mbf-articles-list-results > .row > .col-xl-4').wrapInner('<div id="sticky-search-sidebar"><div id="sticky-search-sidebar-inner"></div></div>');
        stickySearchSidebar = new StickySidebar('#sticky-search-sidebar', {
          topSpacing: 30,
          bottomSpacing: 30,
          containerSelector: '.mbf-articles-list-results > .row',
          innerWrapperSelector: '#sticky-search-sidebar-inner',
          minWidth: 992
        });

        $(window).on('resize scroll', function () {
          articleslistStickySidebarTopSpacing();
          setTimeout(function () {
            articleslistStickySidebarTopSpacing();
          }, 300);
        });
      }
      if ($('.mbf-articles-list-results > .row > .col-xl-4').length) {
        articleslistStickySidebarTopSpacing();
      }

      // Convert facets panel to accordion for tablet and mobile.
      $('.mbf-articles-list-results .col-xl-4 #sticky-search-sidebar-inner').once('mbf-articles-list-accordion-wrapper').wrap('<div class="paragraph-filters-wrapper"></div>');
      $('.mbf-articles-list-results .col-xl-4 .paragraph--type--mba-text', context).once('mbf-articles-list-facets-accordion').mbf_accordion( {
        accordionItem: '.paragraph-filters-wrapper',
        slideElement: '.paragraph-type-mbo-accordion-001',
        icon: true,
        iconElement: '.paragraph-filters-wrapper',
        parentItem: '.paragraph-filters-wrapper',
        containerItem: '.col-xl-4',
        maxWidth: 991,
        openClass: 'openOuter',
        openedClass: 'openedOuter',
      });
      facetsAccordion();
      $(window).resize(function() {
        facetsAccordion();
      });

    },
  };

})(jQuery, Drupal, drupalSettings);
